/* Sautizuri storefront interactions: smooth scroll, reveals, header, menu, search, cart drawer, product form. */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement, body = doc.body;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var $ = function (s, c) { return (c || doc).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); };
  var money = function (cents) {
    var v = (cents / 100).toFixed(2);
    return 'CHF ' + v;
  };
  root.classList.remove('sz-no-js'); root.classList.add('sz-js');

  /* ---------- smooth scroll: only for notched mouse wheels; trackpads keep native scrolling ---------- */
  var smooth = { target: window.scrollY, current: window.scrollY, running: false, enabled: !reduce && finePointer };
  var INNER = '.sz-drawer__body, .sz-search__results, .sz-modal__panel, .sz-menu, .sz-gallery__thumbs, .sz-values__grid, textarea, select';
  function maxScroll() { return Math.max(0, root.scrollHeight - window.innerHeight); }
  function lockedScroll() { return root.classList.contains('sz-lock') || body.classList.contains('sz-menu-open'); }
  function tick() {
    smooth.current += (smooth.target - smooth.current) * 0.16;
    if (Math.abs(smooth.target - smooth.current) < 0.6) { smooth.current = smooth.target; smooth.running = false; }
    window.scrollTo(0, smooth.current);
    if (smooth.running) requestAnimationFrame(tick);
  }
  function isMouseWheel(e) {
    if (e.deltaMode === 1) return true;
    return e.deltaX === 0 && Math.abs(e.deltaY) >= 50 && Math.abs(e.deltaY) % 1 === 0;
  }
  if (smooth.enabled) {
    window.addEventListener('wheel', function (e) {
      if (e.ctrlKey || lockedScroll() || !isMouseWheel(e)) { smooth.running = false; return; }
      if (e.target.closest && e.target.closest(INNER)) return;
      e.preventDefault();
      var delta = e.deltaMode === 1 ? e.deltaY * 32 : e.deltaY;
      if (!smooth.running) smooth.current = smooth.target = window.scrollY;
      smooth.target = Math.min(maxScroll(), Math.max(0, smooth.target + delta));
      if (!smooth.running) { smooth.running = true; requestAnimationFrame(tick); }
    }, { passive: false });
  }
  function scrollToY(y) {
    smooth.running = false;
    window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
  }
  doc.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2) return;
    var el = doc.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
    if (!el) return;
    e.preventDefault();
    scrollToY(el.getBoundingClientRect().top + window.scrollY - 110);
    history.replaceState(null, '', a.getAttribute('href'));
  });

  /* ---------- scroll driven: header, progress, parallax (positions cached, no layout reads per frame) ---------- */
  var headerWrap = $('.sz-header-wrap'), progress = $('.sz-progress span');
  var parallax = $$('[data-sz-parallax]').map(function (el) { return { el: el, speed: parseFloat(el.getAttribute('data-sz-parallax')) || 0.1, mid: 0 }; });
  var vh = window.innerHeight, maxY = maxScroll();
  function measure() {
    vh = window.innerHeight; maxY = maxScroll();
    parallax.forEach(function (p) { p.el.style.transform = ''; var r = p.el.getBoundingClientRect(); p.mid = r.top + window.scrollY + r.height / 2; });
  }
  var lastY = window.scrollY, ticking = false, scrolled = null, hidden = false;
  function onScroll() {
    var y = window.scrollY;
    if (headerWrap) {
      var sc = y > 24; if (sc !== scrolled) { scrolled = sc; headerWrap.classList.toggle('is-scrolled', sc); }
      var hide = hidden;
      if (y < 320 || y < lastY - 4) hide = false;
      else if (y > lastY + 4 && !body.classList.contains('sz-menu-open')) hide = true;
      if (hide !== hidden) { hidden = hide; headerWrap.classList.toggle('is-hidden', hide); }
    }
    if (progress) progress.style.transform = 'scaleX(' + (y / (maxY || 1)).toFixed(4) + ')';
    if (!reduce) parallax.forEach(function (p) {
      var off = (p.mid - y - vh / 2) * -p.speed;
      if (Math.abs(off) < vh) p.el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
    });
    lastY = y; ticking = false;
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { measure(); onScroll(); }, 150); });
  window.addEventListener('load', function () { measure(); onScroll(); });
  measure(); onScroll();

  /* ---------- split headings + reveals ---------- */
  $$('[data-sz-split]').forEach(function (el) {
    var i = 0;
    function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = doc.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(doc.createTextNode(' ')); return; }
            var w = doc.createElement('span'); w.className = 'sz-word';
            var inner = doc.createElement('span'); inner.textContent = part; inner.style.setProperty('--i', i++);
            w.appendChild(inner); frag.appendChild(w);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
      });
    }
    walk(el); el.classList.add('sz-split');
  });
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;
  var pending = $$('[data-sz-reveal], .sz-split, .sz-steps li');
  pending.forEach(function (el) { if (io) io.observe(el); });
  /* fallback for hidden tabs, crawlers and old browsers: reveal anything above the fold line */
  function sweep() {
    var limit = window.innerHeight * 0.95;
    pending = pending.filter(function (el) {
      if (el.classList.contains('is-in')) return false;
      if (el.getBoundingClientRect().top < limit) { el.classList.add('is-in'); if (io) io.unobserve(el); return false; }
      return true;
    });
  }
  var sweepT = 0;
  window.addEventListener('scroll', function () {
    if (!pending.length) return;
    var now = Date.now(); if (now - sweepT < 250) return; sweepT = now; requestAnimationFrame(sweep);
  }, { passive: true });
  window.addEventListener('load', sweep);
  setTimeout(sweep, 120);
  doc.addEventListener('visibilitychange', sweep);

  /* ---------- magnetic buttons + pointer glow ---------- */
  if (finePointer && !reduce) {
    $$('.sz-btn').forEach(function (b) {
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
        b.style.setProperty('--mx', x + 'px'); b.style.setProperty('--my', y + 'px');
        if (b.hasAttribute('data-sz-magnetic')) b.style.transform = 'translate(' + ((x - r.width / 2) * 0.18).toFixed(1) + 'px,' + ((y - r.height / 2) * 0.25).toFixed(1) + 'px)';
      });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });
    $$('[data-sz-tilt]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        el.style.transform = 'perspective(900px) rotateY(' + (x * 6).toFixed(2) + 'deg) rotateX(' + (-y * 6).toFixed(2) + 'deg)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
    var heroArt = $('[data-sz-hero-art]');
    if (heroArt) {
      var layers = $$('[data-depth]', heroArt);
      var px = 0, py = 0, pending2 = false;
      heroArt.closest('section').addEventListener('pointermove', function (e) {
        px = e.clientX / window.innerWidth - .5; py = e.clientY / window.innerHeight - .5;
        if (pending2) return; pending2 = true;
        requestAnimationFrame(function () {
          layers.forEach(function (l) { var d = parseFloat(l.getAttribute('data-depth')); l.style.translate = (px * d * 30).toFixed(1) + 'px ' + (py * d * 30).toFixed(1) + 'px'; });
          pending2 = false;
        });
      });
    }
  }

  /* ---------- announcement rotator ---------- */
  $$('[data-sz-rotator]').forEach(function (wrap) {
    var items = $$('.sz-announce__item', wrap); if (items.length < 2) { if (items[0]) items[0].classList.add('is-active'); return; }
    var i = 0; items[0].classList.add('is-active');
    setInterval(function () {
      var cur = items[i]; cur.classList.remove('is-active'); cur.classList.add('is-leaving');
      setTimeout(function () { cur.classList.remove('is-leaving'); }, 800);
      i = (i + 1) % items.length; items[i].classList.add('is-active');
    }, 4200);
  });

  /* ---------- lock helpers ---------- */
  function lock(on) { root.classList.toggle('sz-lock', on); body.style.overflow = on ? 'hidden' : ''; }
  var lastFocus = null;
  function trap(container, on) {
    if (on) { lastFocus = doc.activeElement; var f = $('input, button, a[href]', container); if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60); }
    else if (lastFocus) { lastFocus.focus({ preventScroll: true }); }
  }

  /* ---------- mobile menu ---------- */
  var burger = $('[data-sz-burger]'), menu = $('.sz-menu');
  function setMenu(open) {
    body.classList.toggle('sz-menu-open', open);
    if (burger) burger.setAttribute('aria-expanded', open);
    if (menu) menu.setAttribute('aria-hidden', !open);
    if (headerWrap) headerWrap.classList.remove('is-hidden');
  }
  if (burger) burger.addEventListener('click', function () { setMenu(!body.classList.contains('sz-menu-open')); });
  if (menu) $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });

  /* ---------- search overlay + predictive search ---------- */
  var search = $('.sz-search');
  function setSearch(open) {
    if (!search) return;
    search.classList.toggle('is-open', open); lock(open); trap(search, open);
  }
  $$('[data-sz-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); setSearch(true); }); });
  $$('[data-sz-search-close]').forEach(function (b) { b.addEventListener('click', function () { setSearch(false); }); });
  if (search) {
    search.addEventListener('click', function (e) { if (e.target === search) setSearch(false); });
    var input = $('input[name="q"]', search), results = $('.sz-search__results', search), timer;
    if (input && results) input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
            results.innerHTML = ps.length ? ps.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
              return '<a class="sz-search__hit" href="' + p.url + '"><img src="' + img + '" alt="" loading="lazy"><span>' + p.title + '</span><strong>CHF ' + Number(p.price).toFixed(2) + '</strong></a>';
            }).join('') : '<p class="sz-search__hint">Keine Treffer für „' + q.replace(/</g, '') + '“.</p>';
          }).catch(function () {});
      }, 180);
    });
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('.sz-drawer'), countEls = $$('[data-sz-cart-count]');
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function setCount(n, bump) {
    countEls.forEach(function (el) {
      el.textContent = n; el.classList.toggle('is-visible', n > 0);
      if (bump) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    var bodyEl = $('.sz-drawer__body', drawer), foot = $('.sz-drawer__foot', drawer);
    if (!cart.item_count) {
      bodyEl.innerHTML = '<div class="sz-empty"><div class="sz-empty__blob sz-shape--pebble"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M5 8h14l-1 12H6L5 8z"/><path d="M9 8a3 3 0 016 0"/></svg></div><p class="sz-h3">Ihr Warenkorb ist leer</p><p class="sz-muted">Sehen Sie sich unsere Kollektion für Damen und Herren an.</p><a class="sz-btn sz-btn--plain" href="/collections/all-products">Zum Shop</a></div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    bodyEl.innerHTML = cart.items.map(function (it, idx) {
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=220' : '';
      var opts = (it.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return esc(o.name) + ': ' + esc(o.value); }).join(' · ');
      return '<div class="sz-line" style="animation-delay:' + idx * 60 + 'ms">' +
        '<a class="sz-line__img" href="' + it.url + '"><img src="' + img + '" alt="' + esc(it.product_title) + '" loading="lazy"></a>' +
        '<div><a class="sz-line__title" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
        (opts ? '<div class="sz-line__meta">' + opts + '</div>' : '') +
        '<div class="sz-line__bottom"><div class="sz-qty" data-key="' + it.key + '">' +
        '<button type="button" data-delta="-1" aria-label="Menge verringern"><svg viewBox="0 0 12 12"><path d="M2 6h8" stroke="currentColor" stroke-width="1.5"/></svg></button>' +
        '<input type="number" value="' + it.quantity + '" min="0" aria-label="Menge">' +
        '<button type="button" data-delta="1" aria-label="Menge erhöhen"><svg viewBox="0 0 12 12"><path d="M2 6h8M6 2v8" stroke="currentColor" stroke-width="1.5"/></svg></button></div>' +
        '<span class="sz-line__price">' + money(it.final_line_price) + '</span></div>' +
        '<button class="sz-line__remove" type="button" data-remove="' + it.key + '">Entfernen</button></div></div>';
    }).join('');
    $('[data-sz-subtotal]', drawer).textContent = money(cart.total_price);
  }
  function fetchCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json(); }).then(renderCart);
  }
  function setDrawer(open) {
    if (!drawer) { if (open) location.href = '/cart'; return; }
    drawer.classList.toggle('is-open', open); drawer.setAttribute('aria-hidden', !open); lock(open); trap(drawer, open);
  }
  window.SZ = { openCart: function () { fetchCart().then(renderCart); setDrawer(true); }, renderCart: renderCart, setCount: setCount };
  $$('[data-sz-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { if (!drawer) return; e.preventDefault(); window.SZ.openCart(); }); });
  if (drawer) {
    $$('[data-sz-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-delta]');
      if (btn) { var wrap = btn.closest('.sz-qty'), inp = $('input', wrap); changeLine(wrap.getAttribute('data-key'), Math.max(0, parseInt(inp.value, 10) + parseInt(btn.getAttribute('data-delta'), 10))); return; }
      var rm = e.target.closest('[data-remove]'); if (rm) changeLine(rm.getAttribute('data-remove'), 0);
    });
    drawer.addEventListener('change', function (e) {
      if (e.target.matches('.sz-qty input')) changeLine(e.target.closest('.sz-qty').getAttribute('data-key'), Math.max(0, parseInt(e.target.value, 10) || 0));
    });
  }
  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    setDrawer(false); setSearch(false); setMenu(false);
    $$('.sz-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); lock(false); });
    var lb = $('.sz-lightbox.is-open'); if (lb) { lb.classList.remove('is-open'); lock(false); }
  });

  /* ---------- cart page qty (form based) ---------- */
  $$('[data-sz-cart-form]').forEach(function (form) {
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-step]'); if (!btn) return;
      var inp = $('input', btn.closest('.sz-qty')); inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) + parseInt(btn.getAttribute('data-step'), 10));
      form.submit();
    });
    form.addEventListener('change', function (e) { if (e.target.matches('.sz-qty input')) form.submit(); });
  });

  /* ---------- accordions with animated height ---------- */
  $$('.sz-acc__item').forEach(function (d) {
    var summary = $('summary', d), bodyEl = $('.sz-acc__body', d);
    if (!summary || !bodyEl || reduce) return;
    summary.addEventListener('click', function (e) {
      e.preventDefault();
      if (d.open) {
        var h = bodyEl.scrollHeight;
        bodyEl.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 450, easing: 'cubic-bezier(.22,1,.36,1)' }).onfinish = function () { d.open = false; };
      } else {
        d.open = true;
        var h2 = bodyEl.scrollHeight;
        bodyEl.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 600, easing: 'cubic-bezier(.22,1,.36,1)' });
      }
    });
  });

  /* ---------- tabs (faq filter) ---------- */
  $$('[data-sz-tabs]').forEach(function (wrap) {
    var btns = $$('[data-filter]', wrap), scope = doc.getElementById(wrap.getAttribute('data-sz-tabs'));
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.classList.toggle('is-active', x === b); x.setAttribute('aria-pressed', x === b); });
        var f = b.getAttribute('data-filter');
        $$('[data-cat]', scope).forEach(function (it) {
          var show = f === 'all' || it.getAttribute('data-cat') === f;
          it.hidden = !show;
          if (show && !reduce) it.animate([{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'none' }], { duration: 500, easing: 'cubic-bezier(.22,1,.36,1)' });
        });
      });
    });
  });

  /* ---------- modals ---------- */
  $$('[data-sz-modal-open]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault(); var m = doc.getElementById(b.getAttribute('data-sz-modal-open'));
      if (m) { m.classList.add('is-open'); lock(true); trap(m, true); }
    });
  });
  $$('.sz-modal').forEach(function (m) {
    m.addEventListener('click', function (e) { if (e.target === m || e.target.closest('[data-sz-modal-close]')) { m.classList.remove('is-open'); lock(false); trap(m, false); } });
  });

  /* ---------- swiss post tracking ---------- */
  $$('[data-sz-track]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = $('input', form).value.replace(/\s+/g, '').trim();
      var msg = $('[data-sz-track-msg]', form.parentNode);
      if (v.length < 8) { if (msg) { msg.hidden = false; msg.textContent = 'Bitte geben Sie die vollständige Sendungsnummer aus Ihrer Versandbestätigung ein.'; } return; }
      if (msg) msg.hidden = true;
      window.open('https://www.post.ch/swisspost-tracking?formattedParcelCodes=' + encodeURIComponent(v), '_blank', 'noopener');
    });
  });

  /* ---------- toc active state ---------- */
  var toc = $('.sz-toc');
  if (toc && io) {
    var links = $$('a', toc), map = {};
    links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
    var tio = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting && map[en.target.id]) { links.forEach(function (l) { l.classList.remove('is-active'); }); map[en.target.id].classList.add('is-active'); } });
    }, { rootMargin: '-20% 0px -70% 0px' });
    Object.keys(map).forEach(function (id) { var h = doc.getElementById(id); if (h) tio.observe(h); });
  }

  /* ---------- product page ---------- */
  $$('[data-sz-product]').forEach(function (pdp) {
    var data = JSON.parse($('[data-sz-product-json]', pdp).textContent);
    var form = $('form[data-sz-form]', pdp), idInput = $('input[name="id"]', form);
    var priceEl = $('[data-sz-price]', pdp), stockEl = $('[data-sz-stock]', pdp), atc = $('[data-sz-atc]', pdp);
    var sizeLabel = $('[data-sz-size-label]', pdp), sticky = $('.sz-sticky-atc');
    var stickyPrice = sticky && $('[data-sz-sticky-price]', sticky);
    function current() { var c = $('input[name="sz-size"]:checked', pdp); return c ? data.variants.filter(function (v) { return String(v.id) === c.value; })[0] : null; }
    function update(v) {
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (sizeLabel) sizeLabel.textContent = v.option1;
      if (stockEl) { stockEl.textContent = v.available ? 'Auf Lager, versandbereit' : 'Diese Grösse ist derzeit nicht verfügbar'; stockEl.classList.toggle('is-out', !v.available); }
      [atc, sticky && $('.sz-btn', sticky)].forEach(function (b) {
        if (!b) return; b.disabled = !v.available;
        var l = $('.sz-btn__label', b); if (l) l.textContent = v.available ? 'In den Warenkorb' : 'Nicht verfügbar';
      });
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url.toString());
    }
    $$('input[name="sz-size"]', pdp).forEach(function (r) { r.addEventListener('change', function () { update(current()); }); });
    update(current());

    var qtyWrap = $('.sz-qty', form);
    if (qtyWrap) qtyWrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-step]'); if (!b) return;
      var inp = $('input', qtyWrap); inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-step'), 10));
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      atc.classList.add('is-loading');
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetchCart(); })
        .then(function (cart) { renderCart(cart); setCount(cart.item_count, true); setDrawer(true); })
        .catch(function (err) {
          var m = $('[data-sz-form-error]', pdp);
          if (m) { m.hidden = false; m.textContent = (err && (err.description || err.message)) || 'Der Artikel konnte nicht hinzugefügt werden.'; }
        })
        .then(function () { atc.classList.remove('is-loading'); });
    });

    if (sticky) {
      $('.sz-btn', sticky).addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) {
        es.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }).observe(atc);
    }

    /* gallery */
    var slides = $$('.sz-gallery__slide', pdp), thumbs = $$('.sz-thumb', pdp), count = $('[data-sz-count]', pdp), idx = 0;
    function go(n) {
      if (!slides.length) return;
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); t.setAttribute('aria-current', i === idx); });
      if (thumbs[idx] && thumbs[idx].parentNode.scrollWidth > thumbs[idx].parentNode.clientWidth) thumbs[idx].parentNode.scrollTo({ left: thumbs[idx].offsetLeft - 20, behavior: 'smooth' });
      if (count) count.textContent = (idx + 1) + ' / ' + slides.length;
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    $$('[data-sz-prev]', pdp).forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); go(idx - 1); }); });
    $$('[data-sz-next]', pdp).forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); go(idx + 1); }); });
    var stage = $('.sz-gallery__stage', pdp), sx = null, moved = false;
    if (stage) {
      stage.addEventListener('pointerdown', function (e) { sx = e.clientX; moved = false; });
      stage.addEventListener('pointerup', function (e) {
        if (sx === null) return; var dx = e.clientX - sx; sx = null;
        if (Math.abs(dx) > 40) { moved = true; go(idx + (dx < 0 ? 1 : -1)); }
      });
      stage.addEventListener('click', function () { if (!moved) openLightbox(idx); });
    }
    var lb = $('.sz-lightbox'), lbImg = lb && $('img', lb);
    function openLightbox(i) {
      if (!lb) return; idx = i; lbImg.src = slides[idx].getAttribute('data-full'); lbImg.alt = $('img', slides[idx]).alt;
      lb.classList.add('is-open'); lock(true);
    }
    if (lb) {
      $('.sz-lightbox__close', lb).addEventListener('click', function () { lb.classList.remove('is-open'); lock(false); });
      $('.sz-lightbox__prev', lb).addEventListener('click', function () { go(idx - 1); lbImg.src = slides[idx].getAttribute('data-full'); });
      $('.sz-lightbox__next', lb).addEventListener('click', function () { go(idx + 1); lbImg.src = slides[idx].getAttribute('data-full'); });
    }
    go(0);
  });

  /* initial cart count */
  if (countEls.length) fetchCart().then(function (c) { setCount(c.item_count); }).catch(function () {});
})();
